import { Controller } from '@hotwired/stimulus'
import { validatePhone } from './phone'

export default class extends Controller<HTMLFormElement> {
  static targets = ['phone', 'error']
  static values = { required: String, prefix: String, invalid: String }

  declare readonly phoneTarget: HTMLInputElement
  declare readonly errorTarget: HTMLElement
  declare readonly requiredValue: string
  declare readonly prefixValue: string
  declare readonly invalidValue: string

  connect(): void {
    this.phoneTarget.setAttribute('aria-describedby', 'driver-phone-guidance driver-phone-error')
    this.phoneTarget.setAttribute(
      'aria-invalid',
      String(this.errorTarget.textContent?.trim() !== '')
    )
  }

  validate(): boolean {
    let { error } = validatePhone(this.phoneTarget.value)
    if (error === 'required' && !this.phoneTarget.required) error = undefined
    const messages = {
      required: this.requiredValue,
      prefix: this.prefixValue,
      invalid: this.invalidValue
    }
    this.errorTarget.textContent = error == null ? '' : messages[error]
    this.phoneTarget.setAttribute('aria-invalid', String(error != null))
    return error == null
  }

  correct(): void {
    if (this.phoneTarget.getAttribute('aria-invalid') === 'true') this.validate()
  }

  submit(event: SubmitEvent): void {
    if (!this.validate()) {
      event.preventDefault()
      event.stopImmediatePropagation()
      this.phoneTarget.focus()
    }
  }
}
